import {Component, OnInit} from '@angular/core';
import {AktionService} from "../../service/aktion.service";
import {AnmeldungService} from "../../service/anmeldung.service";
import {SessionService} from "../../service/session.service";
import {ToastrService} from "ngx-toastr";
import {BackendService} from "../../service/backend.service";
import {SUBNAV_SETTNGS} from "../../app-routing.module";

@Component({
  selector: 'app-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.scss']
})
export class SystemSettingsComponent implements OnInit {
  public readonly SUBNAV_SETTNGS = SUBNAV_SETTNGS;

  anmeldungenAktiv = false;
  anmeldungenDatum!: number;
  deleteAllTxt: string = "";
  newTime: number;

  constructor(
    private readonly aktionService: AktionService,
    private readonly anmeldungService: AnmeldungService,
    private readonly toastr: ToastrService,
    private readonly backendService: BackendService,
    private readonly sessionService: SessionService
  ) {
    this.anmeldungenAktiv = this.anmeldungService.isAnmeldungActive();
    this.anmeldungenDatum = this.anmeldungService.getAnmeldungsbeginn();
    this.newTime = this.anmeldungenDatum;
  }

  ngOnInit(): void {
  }

  async save() {
    try{
      await this.anmeldungService.setAnmeldebeginn(this.newTime)
      this.toastr.success("Gespeichert");
    } catch (e) {
      console.log(e);
      this.toastr.error(e?.msg || e, "Fehler");
    }
  }

  async deleteAll(){
    try{
      await this.backendService.sendRequest("deleteAllData", {sessionId: this.sessionService.session.sessionId}, true)
      this.toastr.success("Alle Daten wurden gel�scht! Bitte neu anmelden.");
      this.sessionService.logout();
    } catch (e) {
      console.log(e);
      this.toastr.error(e?.msg || e, "Fehler");
    }
  }
}
